// extracted by mini-css-extract-plugin
module.exports = {"lightColorCategoryTitle":"CategoryCard_lightColorCategoryTitle__UgQCE","lightBgc":"CategoryCard_lightBgc__F_q_r"};